export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  CHANGE_PASSWORD: "/change-password",
  FORGOT_PASSWORD: "/forgot-password",
  AUDIT_LOG: "/AuditLog",
  LOGIN_LOG: "/LoginLog",
  TRACE_LOG: "/TraceLog",
  CURRENCY: "/Currency",
  CONTENT_GROUP: "/ContentGroup",
  CONTENT_GROUP_ADD: "/ContentGroupAdd",
  CONTENT_GROUP_DETAIL: "/contentGroupDetail",
  CONTENT_GROUP_MEMBER_CATEGORY: "/contentGroupMemberCategory",
  CONTENT_GROUP_MEMBER_CATEGORY_ADD: "/contentGroupMemberCategoryAdd",
  CONTENT_GROUP_MEMBER_CATEGORY_DETAIL: "/contentGroupMemberCategoryDetail",
  CONTENT: "/Content",
  TAG: "/tag",
  TAG_ADD: "/tagAdd",
  TAG_DETAIL: "/tagDetail",
  CONTENT_GROUP_SPLIT_ADD: "/splitContentGroupAdd",
  CONTENT_SPLIT_DETAIL: "/contentSplitDetail",
  CONTENT_SPLIT_DETAIL_MOBILE: "/contentSplitDetail_Mobile",
  LINKED_LicenceS: "/linkedLicences",
  FIRM_TOKEN: "/firmtoken",
  ROLE: "/role",
  ROLE_ADD: "/roleAdd",
  ROLE_DETAIL: "/roleDetail",
  MENU: "/menu",
  MENU_ADD: "/menuAdd",
  MENU_DETAIL: "/menuDetail",
  MENU_HEADER: "/menuHeader",
  MENU_HEADER_ADD: "/menuHeaderAdd",
  MENU_HEADER_DETAIL: "/menuHeaderDetail",
  ALLERGY: "/allergy",
  ALLERGY_DETAIL: "/allergyDetail",
  ALLERGY_ADD: "/allergyAdd",
  STORE: "/store",
  STORE_ADD: "/storeAdd",
  STORE_DETAIL: "/storeDetail",
  HOSPITALITY_MENU: "/hospitalityMenu",
  HOSPITALITY_MENU_ADD: "/hospitalityMenuAdd",
  HOSPITALITY_MENU_DETAIL: "/hospitalityMenuDetail",
  USER: "/users",
  USER_ADD: "/userAdd",
  USER_DETAIL: "/userDetail",
  FIRM: "/Firm",
  FIRM_ADD: "/firmAdd",
  FIRM_DETAIL: "/firmDetail",
  DS: "/ds",
  DS_SETTINGS: "/dsSettings",
  TEMPLATES: "/templates",
  TEMPLATE_EDITOR: "/templateEditor",
  TEMPLATE_ADD: "/templateAdd",
  TEMPLATE_STOCK: "/templateStock",
  TEMPLATE_STOCK_ADD: "/templateStockAdd",
  TEMPLATE_STOCK_EDITOR: "/templateStockEditor",
  SCREEN_SIZE: "/screenSize",
  SCREEN_SIZE_ADD: "/screenSizeAdd",
  SCREEN_SIZE_DETAIL: "/screenSizeDetail",
  PLAYER: "/player",
  PLAYER_ADD: "/playerAdd",
  PLAYER_DETAIL: "/playerDetail",
  CHANNEL: "/channel",
  CHANNEL_ADD: "/channelAdd",
  CHANNEL_DETAIL: "/channelDetail",
  CAMPAIGN: "/campaign",
  CAMPAIGN_ADD: "/campaignAdd",
  CAMPAIGN_DETAIL: "/campaignDetail",
  AREA: "/area",
  AREA_MOBILE: "/area_Mobile",
  AREA_TYPE: "/areaType",
  AREA_TYPE_DETAIL: "/areaTypeDetail",
  AREA_TYPE_ADD: "/areaTypeAdd",
  SETTINGS: "/settings",
  BLOG_POST: "/blogPost",
  BLOG_POST_ADD: "/blogPostAdd",
  BLOG_POST_DETAIL: "/blogPostDetail",
  USER_SUB_ADMIN: "/userSubAdmin",
  USER_SUB_ADMIN_ADD: "/userSubAdminAdd",
  USER_SUB_ADMIN_DETAIL: "/userSubAdminDetail",
  REPORT: "/report",
} as const;
